import React, { useState, useEffect, useCallback } from "react";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  Card,
  CardContent,
  Typography,
  IconButton,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  Grid,
  Box,
  FormGroup,
  Divider,
  Chip,
  Autocomplete,
  CircularProgress,
  Paper,
  Tooltip,
  ListItem,
  Avatar,
} from "@mui/material";
import {
  Folder,
  InsertDriveFile,
  ConfirmationNumber,
  Event,
  ArrowBack,
  ArrowForward,
  Link,
  Delete,
  Add,
  Person,
  CheckCircle,
  Cancel,
  Schedule,
  Label,
  Assignment,
  Create,
  Update,
  Done,
  CloudUpload,
} from "@mui/icons-material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactSelect from "react-select";
import "./Crm.css";
import { ListItemService } from "../../../service/manage/crm/crm_list_item.service";
import DropdownCust from "./Components/DropdownCust";
import TextFieldCust from "./Components/TextfieldCust";
import { FieldListService } from "../../../service/manage/crm/crm_field_list.service";
import { debounce } from "lodash";
import sweetAlert,{
  sweetStatusAlert,
  unsavedChangesAlert,
} from "../../../components/common/SweetAlert";
import { CrmMainService } from "../../../service/manage/crm/crm_main.service";
import SimpleReactValidator from "simple-react-validator";
import AddLinkIcon from "@mui/icons-material/AddLink";
import BookmarkButton from "./Components/BookmarkButton";
import BlockLinkModal from "./Components/BlockLinkModal";
import Checkbox from "@mui/material/Checkbox";
import FileUploadDialog from "./Components/FileUploadDialog";

export default function AnchorTemporaryDrawer({
  open,
  onClose,
  state,
  handleSearchFilter,
  fetchAllReminders,
}) {
  const [trialTitle, setTrialTitle] = useState("");
  const [blockGroupName, setBlockGroupName] = useState("");
  const [blockName, setBlockName] = useState("");
  const [shortText, setShortText] = useState("");
  const [longText, setLongText] = useState("");
  const [reminders, setReminders] = useState([]);
  const [eta, setEta] = useState(null);
  const [searchTags, setSearchTags] = useState("");
  const [blockOwners, setBlockOwners] = useState([]);
  const [mappingLinks, setMappingLinks] = useState("");
  const [attachments, setAttachments] = useState([]);
  const [selectedOption, setSelectedOption] = useState(17);
  const [taskStatusArr, setTaskStatusArr] = useState([]);
  const [blockStatusArr, setBlockStatusArr] = useState([]);
  const [selectedTaskStatus, setSelectedTaskStatus] = useState("");
  const [selectedBlockStatus, setSelectedBlockStatus] = useState("");
  const [statusesLoading, setStatusesLoading] = useState(false);
  const [isUserLoading, setisUserLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [userSearchTerm, setUserSearchTerm] = useState("");
  const [sortColumn, setSortColumn] = useState("user_code");
  const [sortDirection, setSortDirection] = useState("desc");
  const [nextBlockTitle, setNextBlockTitle] = useState("");
  const [parentBlockTitle, setParentBlockTitle] = useState("");
  const [blockTitle, setBlockTitle] = useState("");
  const [saveLoading, setSaveLoading] = useState(false);
  const [, forceUpdate] = useState({});

  const resetState = () => {
    setTrialTitle("");
    setBlockGroupName("");
    setBlockName("");
    setShortText("");
    setLongText("");
    setReminders([]);
    setEta(null);
    setSearchTags("");
    setBlockOwners([]);
    setMappingLinks("");
    setAttachments([]);
    setSelectedOption(17);
    setTaskStatusArr([]);
    setBlockStatusArr([]);
    setSelectedTaskStatus("");
    setSelectedBlockStatus("");
    setStatusesLoading(false);
    setisUserLoading(false);
    setUsers([]);
    setUserSearchTerm("");
    setSortColumn("user_code");
    setSortDirection("desc");
    setSaveLoading(false);
    validator.hideMessages();
    forceUpdate({});
  };

  const [modalOpen, setModalOpen] = useState(false);
  const [linkedBlocks, setLinkedBlocks] = useState([]);

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const [uploadDocumentModal, setUploadDocumentModal] = useState(false);
  const [files, setFiles] = useState([]);

  const handleOpenUpload = () => {
    setUploadDocumentModal(true);
  };
  const handleCloseUpload = () => setUploadDocumentModal(false);

  const handlesetFiles = (newFiles) => setFiles([...files, ...newFiles]);

  const [validator] = useState(() => {
    const validator = new SimpleReactValidator({
      className: "text-danger",
    });
    return validator;
  });

  useEffect(() => {
    if (open) {
      resetState();
      fetchAllUsers();
      fetchDropdownOptions();
    }
  }, [open]);

  const fetchDropdownOptions = async () => {
    try {
      setStatusesLoading(true);

      const [statusResponse] = await Promise.all([
        ListItemService.getListItemById(
          state?.lg_user_id,
          state?.lg_user_table_id
        ),
      ]);

      setTaskStatusArr(statusResponse.data?.taskStatuses);
      setBlockStatusArr(statusResponse.data?.blockStatuses);

      setStatusesLoading(false);
    } catch (error) {
      console.error("Error fetching dropdown options:", error);
      setStatusesLoading(false);
    }
  };

  const fetchAllUsers = async () => {
    setisUserLoading(true);

    try {
      const response = await FieldListService.getAllCrmUsers(
        state?.mid,
        state?.form_list_id,
        state?.lg_user_id,
        state?.lg_user_table_id,
        5000,
        0,
        sortColumn,
        sortDirection,
        userSearchTerm
      );
      setUsers(response?.data?.users || []);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setisUserLoading(false);
    }
  };

  const formatRemindersForSubmission = (reminders) => {
    return reminders.map((reminder) => {
      if (!reminder.date) {
        return `|${reminder.displayOrder}|${reminder.type}`;
      }

      const date = new Date(reminder.date);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      const formattedDate = `${year}${month}${day}${hours}${minutes}`;
      return `${formattedDate}|${reminder.displayOrder}|${reminder.type}`;
    });
  };

  const formatDateToYYYYMMDDHHmm = (date) => {
    if (!date) {
      return "";
    }
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}${month}${day}${hours}${minutes}`;
  };

  const handleBlockOwnersSelect = (event, selectedOptions) => {
    const selectedUsers = selectedOptions.map(
      (option) => `${option.user_id}|${option.user_table_id}`
    );
    setBlockOwners(selectedUsers);
  };

  const handleTaskStatusChange = (event) => {
    setSelectedTaskStatus(event.target.value);
  };

  const handleBlockStatusChange = (event) => {
    setSelectedBlockStatus(event.target.value);
    validator.showMessageFor("selectedBlockStatus");
  };

  const addReminder = () => {
    if (reminders.length === 0 || reminders[reminders.length - 1] !== null) {
      setReminders([
        ...reminders,
        { date: null, displayOrder: reminders.length + 1, type: "" },
      ]);
    }
  };

  const handleReminderChange = (date, index) => {
    const updatedReminders = [...reminders];
    updatedReminders[index].date = date;
    setReminders(updatedReminders);
  };

  const handleTypeChange = (event, index) => {
    const updatedReminders = [...reminders];
    updatedReminders[index].type = event.target.value;
    setReminders(updatedReminders);
  };

  const removeReminder = (index) => {
    const updatedReminders = reminders.filter((_, i) => i !== index);
    setReminders(updatedReminders);
  };

  const handleRadioChange = (event) => {
    setSelectedOption(Number(event.target.value));
  };

  const getTitle = () => {
    switch (selectedOption) {
      case 17:
        return blockGroupName;
      case 18:
        return blockName;
      case 19:
        return shortText;
      default:
        return "";
    }
  };

  const handleSave = async () => {
    if (!validator.allValid()) {
      validator.showMessages();
      forceUpdate({});
      return;
    }
    try {
      setSaveLoading(true);

      const formattedReminders = formatRemindersForSubmission(reminders);
      const formattedEta = formatDateToYYYYMMDDHHmm(eta);

      const fomattedBlockLinks = formatBlockLinkForSubmission(linkedBlocks);

      // Main payload for creating the new block
      const newTicketPayload = {
        node_id: state?.mid,
        user_id: state?.lg_user_id,
        user_table_id: state?.lg_user_table_id,
        create_user_id: state?.lg_user_id,
        trail_title: trialTitle,
        create_user_table_id: state?.lg_user_table_id,
        block_title: blockTitle,
        block_group_name: blockGroupName,
        block_title_id: selectedOption,
        block_name: blockName,
        short_text: shortText,
        long_text: longText,
        reminders: formattedReminders,
        eta: formattedEta,
        search_tags: searchTags,
        block_owners: blockOwners,
        task_status: parseInt(selectedTaskStatus),
        block_status: parseInt(selectedBlockStatus),
        block_creator: [`${state?.lg_user_id}|${state?.lg_user_table_id}`],
        parent_block_title: null,
        next_block_title: null,
        parent_block_id: null,
        next_block_id: null,
        mappings: fomattedBlockLinks,
      };

      // Step 1: Create the new block
      const response = await CrmMainService.crm_update_block(newTicketPayload);

      if (response.success) {
        setSaveLoading(false);
        sweetStatusAlert("Success!", response.message.success, "success");

        onClose();

        await fetchAllReminders();
        await handleSearchFilter();
      } else {
        setSaveLoading(false);
        sweetStatusAlert("Failed!", response.message, "error");
      }
    } catch (error) {
      setSaveLoading(false);
      sweetStatusAlert("Failed!", "Failed to update Block", "error");
    }
  };

  const checkForUnsavedChanges = () => {
    const hasChanges =
      trialTitle !== "" ||
      blockGroupName !== "" ||
      blockName !== "" ||
      shortText !== "" ||
      longText !== "" ||
      reminders.length > 0 ||
      eta !== null ||
      searchTags !== "" ||
      blockOwners.length > 0 ||
      selectedTaskStatus !== "" ||
      selectedBlockStatus !== "";

    return hasChanges;
  };

  const handleCloseModal = async () => { 
    const hasUnsavedChanges = checkForUnsavedChanges(); 
  
    if (hasUnsavedChanges) {
      try {
        const shouldClose = await sweetAlert(
          "Warning",
          "There are unsaved changes. Are you sure you want to close the block?",
          "warning"
        );
        if (!shouldClose) {
          validator.hideMessages();
          forceUpdate({});
          onClose();
        }
      } catch (error) {
        console.error('Error in unsaved changes alert:', error);
      }
    } else {
      validator.hideMessages();
      forceUpdate({});
      onClose();
    }
  };
  const formatBlockLinkForSubmission = (linkedBlocks) => {
    return linkedBlocks.map((block, index) => {
      return `${block.block_id}|${block.displayOrder}|${block.comment}`;
    });
  };

  const handleAddLink = (comment, targetBlock) => {
    setLinkedBlocks((prevLinkedBlocks) => {
      const maxDisplayOrder = prevLinkedBlocks.reduce(
        (max, linkedBlock) => Math.max(max, linkedBlock.displayOrder),
        0
      );
      return [
        ...prevLinkedBlocks,
        {
          block_id: targetBlock.f14,
          displayOrder: maxDisplayOrder + 1,
          comment: comment,
        },
      ];
    });
  };

  const handleRemoveLink = (block) => {
    setLinkedBlocks((prevLinkedBlocks) => {
      const updatedLinkedBlocks = prevLinkedBlocks
        .filter((linkedBlock) => linkedBlock.block_id !== block.block_id)
        .map((linkedBlock, index) => ({
          ...linkedBlock,
          displayOrder: index + 1,
        }));
      return updatedLinkedBlocks;
    });
  };

  const list = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Card
        style={{
          width: "600px",
          borderRadius: "10px",
          boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
        }}
      >
        <CardContent>
          {/* Header */}
          <div className="d-flex align-items-center justify-content-between">
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              marginBottom="8px"
            >
              <Typography
                variant="h6"
                style={{
                  fontWeight: "bold",
                  color: "#172B4D",
                  borderRadius: "4px",
                  padding: "4px",
                }}
              >
                {getTitle() || "N/A"}
              </Typography>
            </Box>
            {/* <BookmarkButton selectedSearchFilter={null} /> */}
          </div>

          <Divider style={{ margin: "8px 0" }} />

          {/* Editable Fields */}
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextFieldCust
                fullWidth
                label="Trial Title"
                value={trialTitle}
                onChange={(e) => setTrialTitle(e.target.value)}
                margin="normal"
                variant="outlined"
                error={validator.message("trialTitle", trialTitle, "required")}
                helperText={validator.message(
                  "trialTitle",
                  trialTitle,
                  "required"
                )}
              />
            </Grid>
            {/* <Grid item xs={12}>
              <TextField
                fullWidth
                label="Block Title"
                value={blockTitle}
                margin="normal"
                onChange={(e) => setBlockTitle(e.target.value)}
                variant="outlined"
                error={validator.message("blockTitle", blockTitle, "required")}
                helperText={validator.message(
                  "blockTitle",
                  blockTitle,
                  "required"
                )}
              />
            </Grid> */}
          </Grid>

          <FormControl component="fieldset" fullWidth>
            <FormGroup>
              <Box display="flex" alignItems="center" mb={1}>
                <RadioGroup value={selectedOption} onChange={handleRadioChange}>
                  <FormControlLabel
                    value={17}
                    control={<Radio />}
                    label="Block Group Name"
                  />
                </RadioGroup>
                <TextFieldCust
                  fullWidth
                  value={blockGroupName}
                  onChange={(e) => setBlockGroupName(e.target.value)}
                  margin="normal"
                  label="Block Group Name"
                  variant="outlined"
                  error={validator.message(
                    "blockGroupName",
                    blockGroupName,
                    "required"
                  )}
                  helperText={validator.message(
                    "blockGroupName",
                    blockGroupName,
                    "required"
                  )}
                />
              </Box>

              <Box display="flex" alignItems="center" mb={1}>
                <RadioGroup value={selectedOption} onChange={handleRadioChange}>
                  <FormControlLabel
                    value={18}
                    control={<Radio />}
                    label="Block Name"
                  />
                </RadioGroup>
                <TextFieldCust
                  fullWidth
                  value={blockName}
                  onChange={(e) => setBlockName(e.target.value)}
                  margin="normal"
                  label="Block Name"
                  variant="outlined"
                  error={validator.message("blockName", blockName, "required")}
                  helperText={validator.message(
                    "blockName",
                    blockName,
                    "required"
                  )}
                />
              </Box>

              <Box display="flex" alignItems="center" mb={1}>
                <RadioGroup value={selectedOption} onChange={handleRadioChange}>
                  <FormControlLabel
                    value={19}
                    control={<Radio />}
                    label="Short Text"
                  />
                </RadioGroup>
                <TextFieldCust
                  fullWidth
                  value={shortText}
                  onChange={(e) => setShortText(e.target.value)}
                  margin="normal"
                  label="Short Text"
                  variant="outlined"
                  error={validator.message("shortText", shortText, "required")}
                  helperText={validator.message(
                    "shortText",
                    shortText,
                    "required"
                  )}
                />
              </Box>
            </FormGroup>
          </FormControl>
          <div style={{ gap: "8px", display: "flex", flexDirection: "column" }}>
            <p className="DateNTime">Long Text</p>
            <TextFieldCust
              fullWidth
              label="Long Text"
              value={longText}
              onChange={(e) => setLongText(e.target.value)}
              margin="normal"
              multiline
              variant="outlined"
              rows={4}
            />

            <Box display="flex" alignItems="center">
              <Schedule color="primary" /> &nbsp;
              <p className="DateNTime">Date & Time – Reminder(s)</p>
            </Box>

            {reminders.map((reminder, index) => (
              <Grid
                container
                key={index}
                spacing={2}
                alignItems="center"
                style={{
                  marginBottom: 10,
                  padding: 10,
                }}
              >
                <Grid item xs={6}>
                  <DatePicker
                    className="date-picker-custom"
                    selected={reminder.date}
                    onChange={(date) => handleReminderChange(date, index)}
                    showTimeSelect
                    timeFormat="HH:mm"
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="MMMM d, yyyy h:mm aa"
                    calendarClassName="custom-calendar"
                    popperClassName="custom-popper"
                    placeholderText="Select date and time"
                    minDate={new Date()}
                    autoComplete="off"
                    onChangeRaw={(e) => e.preventDefault()} // Prevents manual typing
                    onFocus={(e) => e.target.blur()} // Prevents cursor appearance
                    popperPlacement="bottom-start" // Controls calendar popup position
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextFieldCust
                    value={reminder.type}
                    onChange={(event) => handleTypeChange(event, index)}
                    placeholder="Type your reminder here"
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
                <Grid item xs={2}>
                  <IconButton
                    onClick={() => removeReminder(index)}
                    color="error"
                  >
                    <Delete />
                  </IconButton>
                  {index === reminders.length - 1 && reminder.date !== null && (
                    <IconButton
                      onClick={addReminder}
                      color="primary"
                      style={{ marginLeft: "10px" }}
                    >
                      <Add />
                    </IconButton>
                  )}
                </Grid>
              </Grid>
            ))}
          </div>
          {reminders.length === 0 && (
            <Button
              onClick={addReminder}
              variant="outlined"
              startIcon={<Add />}
              style={{ marginTop: "10px" }}
            >
              Add Reminder
            </Button>
          )}

          <Box display="flex" alignItems="center" mt={1} mb={1}>
            <Schedule color="primary" />
            <p className="DateNTime">Date & Time – ETA</p>
          </Box>
          <div style={{ gap: "8px", display: "flex", flexDirection: "column" }}>
            <DatePicker
              className="date-picker-custom"
              selected={eta}
              onChange={(date) => setEta(date)}
              showTimeSelect
              placeholderText="Select ETA"
              dateFormat="Pp"
              margin="normal"
              minDate={new Date()}
              autoComplete="off"
              onChangeRaw={(e) => e.preventDefault()} // Prevents manual typing
              onFocus={(e) => e.target.blur()} // Prevents cursor appearance
              popperPlacement="bottom-start" // Controls calendar popup position
            />
            <p className="DateNTime">Search Tag(s)</p>
            <TextFieldCust
              mt={1}
              fullWidth
              label="Search Tag(s)"
              value={searchTags}
              onChange={(e) => setSearchTags(e.target.value)}
              margin="normal"
              variant="outlined"
            />
          </div>
          <Box mt={1} mb={1}>
            <Typography variant="body2">
              <Person color="primary" style={{ marginRight: "10px" }} />
              Block Owner(s)
            </Typography>
            <Autocomplete
              multiple
              freeSolo
              options={users}
              getOptionLabel={(option) => option.data_concat}
              value={users.filter((user) =>
                blockOwners.includes(`${user.user_id}|${user.user_table_id}`)
              )}
              onChange={handleBlockOwnersSelect}
              onInputChange={(event, newInputValue) =>
                setUserSearchTerm(newInputValue)
              }
              loading={isUserLoading}
              renderInput={(params) => (
                <TextField {...params} placeholder="Select block owners..." />
              )}
            />
          </Box>

          <Box mt={1} mb={1}>
            <Typography variant="body2">
              <Assignment color="primary" style={{ marginRight: "10px" }} />
              Task Status
            </Typography>
            <DropdownCust
              value={selectedTaskStatus}
              onChange={handleTaskStatusChange}
              disabled={statusesLoading}
              placeholder="Select.."
            >
              {statusesLoading ? (
                <option>Loading...</option>
              ) : (
                taskStatusArr.map((option) => (
                  <option
                    key={option.display_order}
                    value={option.display_order}
                  >
                    {option.list_item}
                  </option>
                ))
              )}
            </DropdownCust>
          </Box>
          <Box mt={1} mb={1}>
            <Typography variant="body2">
              <Assignment color="primary" style={{ marginRight: "10px" }} />
              Block Status
            </Typography>
            <DropdownCust
              value={selectedBlockStatus}
              onChange={handleBlockStatusChange}
              disabled={statusesLoading}
              placeholder="Select.."
            >
              {statusesLoading ? (
                <option>Loading...</option>
              ) : (
                blockStatusArr.map((option) => (
                  <option
                    key={option.display_order}
                    value={option.display_order}
                  >
                    {option.list_item}
                  </option>
                ))
              )}
            </DropdownCust>
            {validator.message(
              "selectedBlockStatus",
              selectedBlockStatus,
              "required"
            )}
          </Box>

          <div className="d-flex align-items-center mb-2">
            <Typography variant="subtitle2">
              <p>Linked Tickets</p>
            </Typography>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "start",
              }}
            >
              <Tooltip title="Mapping (links)">
                <IconButton onClick={handleOpen}>
                  <AddLinkIcon />
                </IconButton>
              </Tooltip>
            </div>
            <div
              style={{ display: "flex" }}
              sx={{
                flexDirection: "row",
                listStyle: "none",
                p: 0.5,
                m: 0,
              }}
              component="ul"
            >
              {linkedBlocks?.map((block, index) => {
                return (
                  <ListItem
                    key={index}
                    sx={{ width: "auto", padding: "4px", minHeight: "8px" }}
                  >
                    <Chip
                      label={`[${block.block_id}] ${
                        block.comment.length > 7
                          ? `${block.comment.slice(0, 7)}...`
                          : block.comment
                      }`}
                      avatar={
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Checkbox
                            size="small"
                            sx={{
                              padding: "0 8px",
                              "&.Mui-checked": {
                                color: "#773e87",
                              },
                            }}
                          />
                          {block.displayOrder && (
                            <Avatar sx={{ marginLeft: "2px" }}>
                              {block.displayOrder}
                            </Avatar>
                          )}
                        </Box>
                      }
                      onDelete={() => handleRemoveLink(block)}
                      sx={{
                        "& .MuiChip-avatar": {
                          width: "auto",
                          marginLeft: "0",
                        },
                        backgroundColor: "#f9ebfc",
                        "&:hover": {
                          backgroundColor: "#f0d9f5",
                        },
                      }}
                    />
                  </ListItem>
                );
              })}
            </div>
          </div>
          <div className="d-flex align-items-center" mt={1} mb={1}>
            <Typography variant="body2">
              <Folder color="primary" style={{ marginRight: "10px" }} />
              Attachments
            </Typography>
            <Button
              variant="outlined"
              startIcon={<CloudUpload />}
              style={{ marginLeft: "10px" }}
              onClick={handleOpenUpload}
            >
              Upload Attachment
            </Button>
          </div>

          {/* Save Button */}
          <Button
            onClick={handleSave}
            variant="contained"
            sx={{
              backgroundColor: "#1ea5d0",
              color: "white",
              marginTop: "16px",
            }}
            fullWidth
            disabled={saveLoading}
          >
            {saveLoading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Create"
            )}
          </Button>
        </CardContent>
      </Card>
    </div>
  );

  const isMobile = useMediaQuery("(max-width:600px)");
  const drawerWidth = isMobile ? 300 : 600;

  return (
    <Drawer anchor="right" open={open} onClose={handleCloseModal}>
      <div style={{ width: drawerWidth, padding: 20 }}>
        {list()}
        {modalOpen && (
          <BlockLinkModal
            selectedBlock={null}
            handleClose={handleClose}
            modalOpen={modalOpen}
            handleAddLink={handleAddLink}
            linkedBlocks={linkedBlocks}
          />
        )}
        {uploadDocumentModal && (
          <FileUploadDialog
            open={uploadDocumentModal}
            onClose={handleCloseUpload}
            multiple={true}
            selectedBlock={null}
            setFiles={handlesetFiles}
            files={files}
            type={"admin"}
          />
        )}
      </div>
    </Drawer>
  );
}
